import { Language } from "./contexts/LanguageContext";

// Translation interface for multi-language support
export interface Translations {
  appTitle: string;
  appSubtitle: string;
  searchPlaceholder: string;
  searchButton: string;
  searchHelpText: string;
  loading: string;
  noResults: string;
  resultsFor: string;
  group: string;
  groups: string;
  synonymGroup: string;
  partOfSpeech: string;
  register: string;
  frequency: string;
  note: string;
  examples: string;
  footerText: string;
  errorOccurred: string;
  translationDE: string;
  translationEN: string;
  translationUK: string;
  filters: string;
  all: string;
  minFrequency: string;
  clearFilters: string;
  loginTitle: string;
  loginSubtitle: string;
  loginWithGoogle: string;
  logout: string;
  welcome: string;
}

export const translations: Record<Language, Translations> = {
  de: {
    appTitle: "Deutsches Synonymwörterbuch",
    appSubtitle: "Für fortgeschrittene Deutschlerner (C1/C2)",
    searchPlaceholder: "Suche ein deutsches Wort...",
    searchButton: "Suchen",
    searchHelpText: "Suche auf Deutsch, Englisch oder Ukrainisch",
    loading: "Suche...",
    noResults: "Keine Ergebnisse für",
    resultsFor: "Ergebnisse für",
    group: "Gruppe",
    groups: "Gruppen",
    synonymGroup: "Synonymgruppe",
    partOfSpeech: "Wortart",
    register: "Register",
    frequency: "Häufigkeit",
    note: "Hinweis",
    examples: "Beispiele",
    footerText: "Übersetzungen: Deutsch • Ukrainisch • Englisch",
    errorOccurred: "Ein Fehler ist aufgetreten",
    translationDE: "DE",
    translationEN: "EN",
    translationUK: "UK",
    filters: "Filter",
    all: "Alle",
    minFrequency: "Minimale Häufigkeit",
    clearFilters: "Filter zurücksetzen",
    loginTitle: "Willkommen",
    loginSubtitle: "Melden Sie sich an, um auf das deutsche Synonymwörterbuch zuzugreifen",
    loginWithGoogle: "Mit Google anmelden",
    logout: "Abmelden",
    welcome: "Willkommen",
  },
  en: {
    appTitle: "German Synonym Dictionary",
    appSubtitle: "For advanced German learners (C1/C2)",
    searchPlaceholder: "Search for a German word...",
    searchButton: "Search",
    searchHelpText: "Search in German, English, or Ukrainian",
    loading: "Searching...",
    noResults: "No results for",
    resultsFor: "Results for",
    group: "group",
    groups: "groups",
    synonymGroup: "Synonym group",
    partOfSpeech: "Part of speech",
    register: "Register",
    frequency: "Frequency",
    note: "Note",
    examples: "Examples",
    footerText: "Translations: German • Ukrainian • English",
    errorOccurred: "An error occurred",
    translationDE: "DE",
    translationEN: "EN",
    translationUK: "UK",
    filters: "Filters",
    all: "All",
    minFrequency: "Minimum Frequency",
    clearFilters: "Clear Filters",
    loginTitle: "Welcome",
    loginSubtitle: "Sign in to access the German synonym dictionary",
    loginWithGoogle: "Sign in with Google",
    logout: "Logout",
    welcome: "Welcome",
  },
  uk: {
    appTitle: "Німецький словник синонімів",
    appSubtitle: "Для просунутих учнів німецької мови (C1/C2)",
    searchPlaceholder: "Пошук німецького слова...",
    searchButton: "Пошук",
    searchHelpText: "Пошук німецькою, англійською або українською",
    loading: "Пошук...",
    noResults: "Немає результатів для",
    resultsFor: "Результати для",
    group: "група",
    groups: "груп",
    synonymGroup: "Група синонімів",
    partOfSpeech: "Частина мови",
    register: "Реєстр",
    frequency: "Частота",
    note: "Примітка",
    examples: "Приклади",
    footerText: "Переклади: Німецька • Українська • Англійська",
    errorOccurred: "Виникла помилка",
    translationDE: "НІМ",
    translationEN: "АНГ",
    translationUK: "УКР",
    filters: "Фільтри",
    all: "Всі",
    minFrequency: "Мінімальна частота",
    clearFilters: "Очистити фільтри",
    loginTitle: "Ласкаво просимо",
    loginSubtitle: "Увійдіть, щоб отримати доступ до німецького словника синонімів",
    loginWithGoogle: "Увійти через Google",
    logout: "Вийти",
    welcome: "Ласкаво просимо",
  },
};

export const useTranslations = (language: Language): Translations => {
  return translations[language];
};
